<template>
  <div class="safe-area-bg"></div>
  <section class="main_layout">
    <LazyLayoutTopNavBar
      :toggle-profile="toggleProfile"
      :open-profile="openProfile"
    />
    <LazyLayoutMobileNavBar
      :toggle-profile="toggleProfile"
      v-if="$isMobile()"
    />

    <Transition
      :name="windowInnerWidth <= 1200 ? 'profile_menu-mobile' : 'profile_menu'"
      v-click-outside="closeOutside"
    >
      <LazyLayoutMenuProfileMenu
        v-if="isProfileMenuOpen"
        :toggle-profile="toggleProfile"
      />
    </Transition>

    <div class="main_layout_page d-flex-column justify-start">
      <div class="d-flex-column align-start">
        <div
          class="warning_message global_warning d-flex-row justify-start"
          v-if="genericStore.globalWarning?.id"
        >
          <NuxtImg
            src="/images/icons/warning-icon-2.webp"
            alt="warning_icon"
            class="warning_icon_2"
            height="48"
            width="48"
          />
          <div class="d-flex-column justify-start align-start gap-1">
            <p class="t-white font-family-2 bold-xxl">
              {{ genericStore.globalWarning?.title }}
            </p>

            <p class="t-grey font-family-2 medium-m">
              {{ genericStore.globalWarning?.season_title }}
            </p>
          </div>
        </div>
        <Suspense>
          <slot></slot>
        </Suspense>
      </div>
    </div>
    <DelayHydration>
      <ClientOnly>
        <LazyLayoutFooter
          v-if="
            !route.fullPath?.includes('dashboard') &&
            !route.fullPath?.includes('blog')
          "
        />
      </ClientOnly>
    </DelayHydration>
  </section>
</template>

<script setup>
// HOOKS
const router = useRouter();
const genericStore = useGenericStore();
const { getUser, getUtm, getUtmChanged } = useUserStore();
// REFS
const isProfileMenuOpen = ref(false);
const hasOpenedFully = ref(false);
const route = router.currentRoute;
const isBlogPage = computed(() => {
  if (route.value.meta?.pageInfo?.name === "blog-detail") return true;
  return false;
});
// METHODS

const toggleProfile = () => {
  isProfileMenuOpen.value = !isProfileMenuOpen.value;

  if (!isProfileMenuOpen.value) {
    hasOpenedFully.value = false;
  }
  toggleBodyScroll(isProfileMenuOpen.value);
};
const openProfile = () => {
  if (!isProfileMenuOpen.value) {
    isProfileMenuOpen.value = true;
    window.setTimeout(() => {
      hasOpenedFully.value = true;
    }, 800);
    toggleBodyScroll(isProfileMenuOpen.value);
  }
};

const closeOutside = () => {
  if (isProfileMenuOpen.value && hasOpenedFully.value) {
    isProfileMenuOpen.value = false;
    hasOpenedFully.value = false;
    toggleBodyScroll(isProfileMenuOpen.value);
  }
};

const windowInnerWidth = computed(() => {
  if (!window?.innerWidth) {
    return 0;
  } else return window.innerWidth;
});

onMounted(() => {});
onNuxtReady(() => {
  if (getUser?.id) {
    const createdAt = new Date(getUser.created_at);
    const options = {
      timeZone: "Europe/Berlin",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true, // Use 12-hour clock
      timeZoneName: "short",
    };

    // Format the date
    const formattedDate = new Intl.DateTimeFormat("en-US", options).format(
      createdAt
    );

    // Get UNIX timestamp (in seconds)
    const unixTimestamp = Math.floor(createdAt.getTime() / 1000);
    const utmDataSet = getUtmChanged;
    console.log("utmDataSet", utmDataSet);
    window?.analytics?.identify(
      getUser.id,
      {
        email: getUser.email,
        name: getUser.username,
        created_at: `${unixTimestamp}`, // Use UNIX timestamp here
        traits: {
          ...utmDataSet,
        },
      },
      {}
    );
  } else {
    const utmDataSet = getUtmChanged;
    console.log("utmDataSet", utmDataSet);

    window?.analytics?.identify({
      traits: {
        ...utmDataSet,
      },
    });
  }
});
</script>
